import _ from 'lodash';
// can probably be removed after settings v3
export var get = function (object, key, propName) {
    // For history!
    propName = propName || 'com.wix.restaurants';
    var obj = JSON.parse((object.properties || {})[propName] || '{}');
    var parts = key.split('.');
    while (parts.length > 0) {
        var part = parts.shift();
        if (part) {
            if (part.substr(0, 1) === '?') {
                return _.includes(obj || [], part.substr(1));
            }
            else {
                obj = (obj || {})[part];
            }
        }
    }
    return obj;
};
export var set = function (object, key, value, propName) {
    // For history!
    propName = propName || 'com.wix.restaurants';
    object.properties = object.properties || {};
    var parent = null;
    var lastPart = null;
    var obj = JSON.parse(object.properties[propName] || '{}');
    var top = obj;
    var arrayVal = null;
    var parts = key.split('.');
    while (parts.length > 0) {
        var part = parts.shift();
        if (part) {
            if (part.substr(0, 1) === '?') {
                arrayVal = part.substr(1);
                obj = _.isEmpty(obj) ? [] : obj;
            }
            else {
                lastPart = part;
                parent = obj;
                obj[part] = obj[part] || {};
                obj = obj[part];
            }
        }
    }
    if (!parent) {
        throw new Error();
    }
    if (lastPart) {
        if (arrayVal) {
            parent[lastPart] = value
                ? _.union(obj, [arrayVal])
                : _.without(obj, arrayVal);
        }
        else {
            parent[lastPart] = value;
        }
    }
    object.properties[propName] = JSON.stringify(top);
};
//# sourceMappingURL=propertiesLogic.js.map